import { render, staticRenderFns } from "./blockimage.vue?vue&type=template&id=65ef74fd&scoped=true&"
import script from "./blockimage.vue?vue&type=script&lang=js&"
export * from "./blockimage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ef74fd",
  null
  
)

export default component.exports